import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IProductSize,
    IProductSizeState,
    IProductSizeFormValues,
    IProductSizeErrors,
} from "../../../types/product/productSizeInterfaces";

export const initialForm: IProductSizeFormValues = {
    id: 0,
    code: "",
    name: "",
};

export const initialState: IProductSizeState = {
    productSizes: [],
    productSizesDropdown: [],
    form: initialForm,
    formErrors: {},
    isSubmit: false,
    isCreateModalOpen: false,
    isEditModalOpen: false,
};

export const productSizeSlice = createSlice({
    name: "productSizes",
    initialState,
    reducers: {

        // ========================================
        // FETCH
        // ========================================
        loadingProductSizes: (state, action: PayloadAction<IProductSize[]>) => {
            state.productSizes = action.payload;
        },

        loadingProductSizesDropdown: (
            state,
            action: PayloadAction<{ id: number; name: string }[]>
        ) => {
            state.productSizesDropdown = action.payload;
        },

        // ========================================
        // FORM
        // ========================================
        updateFormField: (
            state,
            action: PayloadAction<{ field: string; value: any }>
        ) => {
            const { field, value } = action.payload;
            (state.form as any)[field] = value;
        },

        setForm: (state, action: PayloadAction<IProductSizeFormValues>) => {
            state.form = action.payload;
        },

        resetForm: (state) => {
            state.form = initialForm;
            state.formErrors = {};
            state.isSubmit = false;
        },

        // ========================================
        // FORM ERRORS
        // ========================================
        setFormErrors: (state, action: PayloadAction<IProductSizeErrors>) => {
            state.formErrors = action.payload;
        },

        clearFormErrors: (state) => {
            state.formErrors = {};
        },

        // ========================================
        // SUBMIT FLAG
        // ========================================
        setSubmit: (state, action: PayloadAction<boolean>) => {
            state.isSubmit = action.payload;
        },

        // ========================================
        // MODALS
        // ========================================
        openCreateModal: (state) => {
            state.isCreateModalOpen = true;
        },

        closeCreateModal: (state) => {
            state.isCreateModalOpen = false;
        },

        openEditModal: (state) => {
            state.isEditModalOpen = true;
        },

        closeEditModal: (state) => {
            state.isEditModalOpen = false;
        },

        // ========================================
        // CRUD CORE
        // ========================================
        addProductSize: (state, action: PayloadAction<IProductSize>) => {
            state.productSizes.push(action.payload);
        },

        updateProductSize: (state, action: PayloadAction<IProductSize>) => {
            state.productSizes = state.productSizes.map((size) =>
                size.id === action.payload.id ? { ...size, ...action.payload } : size
            );
        },

        toggleStateProductSize: (
            state,
            action: PayloadAction<{ id: number; status: boolean }>
        ) => {
            const { id, status } = action.payload;
            state.productSizes = state.productSizes.map((size) =>
                size.id === id ? { ...size, status } : size
            );
        },
    },
});

export const {
    loadingProductSizes,
    loadingProductSizesDropdown,
    updateFormField,
    setForm,
    resetForm,
    setFormErrors,
    clearFormErrors,
    setSubmit,
    openCreateModal,
    closeCreateModal,
    openEditModal,
    closeEditModal,
    addProductSize,
    updateProductSize,
    toggleStateProductSize,
} = productSizeSlice.actions;

export default productSizeSlice.reducer;
